import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pointer",
  "use": "icon-pointer-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-pointer\"><path d=\"m6.122 5.024 19.247 6.036a.914.914 0 0 1 .02 1.503l-5.238 3.716 6.582 6.596a.91.91 0 0 1 0 1.29l-2.567 2.567a.91.91 0 0 1-1.29 0l-6.597-6.581-3.716 5.239a.912.912 0 0 1-1.616-.257L7.233 13.219l-.006.004-.487-1.56-.432-1.412-.008.003-.528-1.69h.01l-.74-2.38a.913.913 0 0 1 1.08-1.16m1.18 2.279 4.839 15.525 3.273-4.614a.912.912 0 0 1 1.39-.119l6.716 6.701 1.277-1.276-6.702-6.716a.913.913 0 0 1 .118-1.39l4.616-3.273z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol